import React, { useState, useEffect, useRef  } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from "primereact/inputtext";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Menu } from 'primereact/menu';
// import { useFormik } from "formik";
import { Chart } from 'primereact/chart';


export const UserMasterForm = () => {
    const [data, setData] = useState([]);
    const menu = useRef(null);
    const [currentUser, setCurrentUser] = useState({});
    const [newForm, setNewForm] = useState(false);
    const [filterDialog, setFilterDialog] = useState(false);
    const [filterObj, setFilterObj] = useState('');

    // select field
  const channel = [
    { name: 'Active', value: 1 },
    { name: 'In-Active', value: 2 },
    { name: 'Archive', value: 3 },
    { name: 'Reject', value: 4 },
    
];
// const formik = useFormik({
//     initialValues: {
//       firstName: "",
//       lastName: "",
//       email: "",
//       phone: "",
//       status: "",
//     },
//     onSubmit: (data) => {
//     },
//   });
  const cancelHandler = () => {
    // formik.resetForm();
    setNewForm(false);
  };
  useEffect(() => {
    setData(data1);
}, []);
const status = [
    { label: 'Active', value: 1 },
    { label: 'Inactive', value: 2 },
  ];
    const data1 = [
        {
            statusNo: 1,
            firstName: 'Shubham',
            lastName: 'kumawat',
            email:"shubham@espire.com",
            mobile: 7610449755,
        },
        {
            statusNo: 2,
            firstName: 'Saurabh',
            lastName: 'kumar',
            email:"saurabh@espire.com",
            mobile: 1234567890,
        },
        {
            statusNo: 3,
            firstName: 'Dinesh',
            lastName: 'kumar',
            email:"dinesh@espire.com",
            mobile: 9087654321,
        }

    ]

    const AddNewuser = () => {
        return (
          <div>
            <Dialog header="Add User" visible={newForm} position="right" modal style={{ width: '500px' }}
              onHide={() => setNewForm(false)}
              draggable={false} resizable={false}>
              <form 
            //   onSubmit={formik.handleSubmit}
              >
                <div className="grid p-fluid">
                  <div className="col-6 field">
                    <label htmlFor="firstName" >
                      First Name<span style={{color: 'red'}}>*</span>
                    </label>
                    <span className="p-float-label">
                      <InputText id="firstName" name="firstName"
                    //    value={formik.values.firstName} onChange={formik.handleChange}
                     />
                    </span>
                  </div>
                  <div className="col-6 field">
                    <label htmlFor="lastName" >
                      Last Name<span style={{color: 'red'}}>*</span>
                    </label>
                    <span className="p-float-label">
                      <InputText id="lastName" name="lastName"
                    //    value={formik.values.lastName} onChange={formik.handleChange}
                     />
                    </span>
                  </div>
                  <div className="col-6 field">
                    <label htmlFor="email" >
                      Email Address<span style={{color: 'red'}}>*</span>
                    </label>
                    <span className="p-float-label">
                      <InputText id="email" name="email"
                    //    value={formik.values.email} onChange={formik.handleChange} 
                     />
                    </span>
                  </div>
                  <div className="col-6 field">
                    <label htmlFor="phone" >
                      Phone<span style={{color: 'red'}}>*</span>
                    </label>
                    <span className="p-float-label">
                      <InputText id="phone" name="phone"
                    //    value={formik.values.phone} onChange={formik.handleChange}
                    />
                    </span>
                  </div>
                  <div className="col-6 field">
                    <label htmlFor="status" >
                      Status
                    </label>
                    <span className="p-float-label">
                      <Dropdown id="status" name="status" 
                    //   value={formik.values.status} onChange={formik.handleChange}
                     options={status} />
                    </span>
                  </div>
                </div>
                <div className="col-12">
                  <Button type="submit" icon="pi pi-plus" label="Add User" className="p-button-rounded" />
                  <Button type="button" icon="pi pi-times" label="Cancel" className="p-button-rounded p-button-secondary ml-2" onClick={cancelHandler} />
                </div>
              </form>
            </Dialog>
          </div>
        );
      };
      const SearchUser = () => {
        return (
          <div>
            <Dialog header="Search User" visible={filterDialog} position="right" modal style={{ width: '500px' }}
              onHide={() => setFilterDialog(false)}
              draggable={false} resizable={false}>
              <form 
            //   onSubmit={formik.handleSubmit}
              >
                <div className="grid p-fluid">
                  <div className="col-6 field">
                    <label htmlFor="firstName" >
                      First Name<span style={{color: 'red'}}>*</span>
                    </label>
                    <span className="p-float-label">
                      <InputText id="firstName" name="firstName"
                    //    value={formik.values.firstName} onChange={formik.handleChange}
                     />
                    </span>
                  </div>
                  <div className="col-6 field">
                    <label htmlFor="lastName" >
                      Last Name<span style={{color: 'red'}}>*</span>
                    </label>
                    <span className="p-float-label">
                      <InputText id="lastName" name="lastName"
                    //    value={formik.values.lastName} onChange={formik.handleChange}
                     />
                    </span>
                  </div>
                  <div className="col-6 field">
                    <label htmlFor="email" >
                      Email Address<span style={{color: 'red'}}>*</span>
                    </label>
                    <span className="p-float-label">
                      <InputText id="email" name="email"
                    //    value={formik.values.email} onChange={formik.handleChange} 
                     />
                    </span>
                  </div>
                  <div className="col-6 field">
                    <label htmlFor="phone" >
                      Phone<span style={{color: 'red'}}>*</span>
                    </label>
                    <span className="p-float-label">
                      <InputText id="phone" name="phone"
                    //    value={formik.values.phone} onChange={formik.handleChange}
                    />
                    </span>
                  </div>
                  <div className="col-6 field">
                    <label htmlFor="status" >
                      Status
                    </label>
                    <span className="p-float-label">
                      <Dropdown id="status" name="status" 
                    //   value={formik.values.status} onChange={formik.handleChange}
                     options={status} />
                    </span>
                  </div>
                </div>
                <div className="col-12">
                  <Button type="submit" icon="pi pi-plus" label="Add User" className="p-button-rounded" />
                  <Button type="button" icon="pi pi-times" label="Cancel" className="p-button-rounded p-button-secondary ml-2" onClick={cancelHandler} />
                </div>
              </form>
            </Dialog>
          </div>
        );
      };
    const tableHeader = () => {
        return (
          <div>
            <div className="grid">
              <div className="col mt-3 mb-2" style={{ paddingLeft: "25px", paddingRight: "21px" }}>
                <span className="heading">
                  User's List
                  {/* <div className="heading-actions"> */}
                    {/* <div> */}
                    <Button icon="pi pi-replay" className="p-button-rounded p-button-help p-button-text" aria-label="Replay" onClick={() => { setFilterObj('') }} />
                    <Button icon="pi pi-filter" className="p-button-rounded p-button-help p-button-text" aria-label="Filter" onClick={() => setFilterDialog(true)} />
                    <Button icon="pi pi-plus" className="p-button-rounded p-button-help p-button-text" aria-label="add" onClick={() => setNewForm(true)} />
                    {/* </div>
                  </div> */}
                </span>
              </div>
            </div>
          </div>
        );
      };
    
    const ActionBodyTemplate = (rowData) => {
        let items;
        items = [
            { label: 'Views', items: [{ label: "Change Role", icon: "pi pi-user" },] },
            { label: 'Assignments', items: [{ label: "Action 2", icon: "pi pi-user-plus" },] },
            { label: 'Updates', items: [ { label: "Action 3", icon: "pi pi-user-edit" },] }
          ];
          return (
            <>
              <Menu id={"m-" + rowData.id} model={items} popup ref={menu} />
              <Button className="p-button-rounded p-button-text" id={"b-" + rowData.id} icon="pi pi-ellipsis-v"
                onClick={(event) => { setCurrentUser(rowData); menu.current.toggle(event) }} aria-controls={"m-" + rowData.id} aria-haspopup />
            </>
          );
    };
    
    return (
        <div>
            {AddNewuser()}
            {SearchUser()}
            <DataTable value={data} header={tableHeader}>
                <Column field="statusNo" header="S.NO"></Column >
                <Column field="firstName" header="First Name"></Column >
                <Column field="lastName" header="Last Name"></Column >
                <Column field="email" header="Email"></Column >
                <Column field="mobile" header="Phone"></Column >
                <Column header="Action" body={ActionBodyTemplate}></Column >
            </DataTable>
        </div>
    );
}
